module.exports = {
    bindings: {
        active: '<',
        ecicsCount: '<',
        section: '<',
        onClickChapter: '&',
        onClickSection: '&'
    },
    controller: sectionController,
    templateUrl: 'nomenclature/components/nomenclature-section.html',
};

sectionController.$inject = [
    'applicationStateService'
];

function sectionController(
    state
) {
    var vm = {
        $onInit: attached,
        clickChapter: clickChapter,
        clickSection: clickSection,
        state: state
    };
    return vm;

    function attached() {
    }

    function clickSection() {
        vm.onClickSection({ section: vm.section });
    }

    function clickChapter(chapter) {
        vm.onClickChapter({ chapter: chapter });
    }
}